import { Button, ButtonProps } from '@spotify-internal/encore-web';

const SectionButton = ({
  size = 'small',
  variant = 'tertiary',
  ...props
}: ButtonProps) => <Button size={size} variant={variant} {...props} />;

export default SectionButton;
